/** Umstieg einer laufenden Partie auf neuere Spielregeln, nur zwischen zwei Legislaturen und nur im Einzelspieler. */
import { S, log } from './state';
import { allIssues, allAxes } from './axes';
import { RULES, RULE_NOTES, verOf } from './version';
import { newAdm } from './adm';
import { newCom } from './com';

/** Kann die laufende Partie jetzt auf die aktuellen Regeln umsteigen? */
export const canUpgrade = (): boolean => !!S && !S.mp && S.phase === 'review' && verOf(S) < RULES;

/** Neue Regeln übernehmen. `to` steht im Zugprotokoll, damit ein späteres Nachspielen dieselbe Version wählt. */
export function upgradeRules(to: number) {
  if (S.mp || S.phase !== 'review') return;
  const from = verOf(S);
  if (!Number.isInteger(to) || to <= from || to > RULES) return;
  S.ver = to;
  // Neue Probleme und Themen der höheren Version anlegen (noch nicht aktiv)
  for (const I of allIssues()) if (!S.issues[I.id]) S.issues[I.id] = { sev: I.sev, prev: I.sev, cut: 0, law: null, on: false } as any;
  for (const a of allAxes()) { if (S.you[a] == null) S.you[a] = 0; if (S.agree && S.agree[a] == null) S.agree[a] = S.you[a]; }
  if (to >= 4 && !S.adm) S.adm = newAdm();
  if (to >= 5 && !S.com) S.com = newCom();
  const notes = Object.keys(RULE_NOTES).map(Number).filter((v) => v > from && v <= to).flatMap((v) => RULE_NOTES[v]);
  log(`Neue Spielregeln ab der nächsten Legislatur: ${notes.join(' ')}`, 'good');
}
